import { styled } from '@styles/stitches';

export const Container = styled('div', {
  padding: '0 $space$3',
  // border: '1px dashed red',

  '@bp1': {
    padding: '0 $space$2',
    // border: '1px dashed green',
  },

  '@bp2': {
    padding: '0 $space$1',
    // border: '1px dashed blue',
  },
});
